import React, { useState, Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Tooltip,
} from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import { withRouter } from "react-router";
import { Preview } from "../../../../helpers/ui/FileInput";
import apiResponse from "../../../../services/apiResponse";

import DetailBloc from "./Blocs/DetailBloc";

import moment from "moment";

// format dd/mm/yyy
var format_dmy = function (tgl) {
  return moment(tgl).format("DD-MM-YYYY");
};

class IndexView extends Component {
  detailBloc = new DetailBloc();

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      tooltipStyle: {
        marginBottom: 2,
        backgroundColor: "#000",
        color: "#FFF",
        border: "1px solid #000",
      },
      submission_uuid: "",
      dokumen_persyaratan: [],
    };
  }

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response,
              submission_uuid: response.retired_employee_submission_uuid,
            });
            //console.log(response)
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.detailBloc.documentChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              dokumen_persyaratan: response.result,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });
    this.detailBloc.fetchDocument({ uuid: queryParams.get("uuid") });
  }

  componentWillUnmount() {
    this.detailBloc.detailChannel?.unsubscribe();
    this.detailBloc.documentChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <style>
          {`
            .custom-arrow::before {
              content: "";
              position: absolute;
              width: 0;
              height: 0;
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
              border-right: 6px solid #000; /* Same color as tooltip background */
              top: 50%; /* Position arrow at the vertical center */
              left: -5px; /* Adjust position from the left */
              transform: translateY(-50%); /* Center the arrow vertically */
            }
          `}
        </style>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Detail Usulan Pemberhentian</CardTitle>
                  <CardSubtitle className="mb-3">
                    Informasi Detail Usulan Pemberhentian
                  </CardSubtitle>
                  <hr />

                  <Row className="mb-3">
                    <label className="col-md-3">NIP</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_nip !== ""
                            ? this.state.detail.retired_employee_nip
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Nama</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_name !== ""
                            ? this.state.detail.retired_employee_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Unit Kerja</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_work_unit_name !==
                          ""
                            ? this.state.detail.retired_employee_work_unit_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Jabatan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_position_name !==
                          ""
                            ? this.state.detail.retired_employee_position_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">TMT Jabatan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_position_tmt !==
                          ""
                            ? format_dmy(
                                this.state.detail.retired_employee_position_tmt
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Golongan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_level_name !== ""
                            ? this.state.detail.retired_employee_level_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tanggal Lahir</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_birth_date !== ""
                            ? format_dmy(
                                this.state.detail.retired_employee_birth_date
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Jenis Kelamin</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.gender_name !== ""
                            ? this.state.detail.gender_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tanggal Pemberhentian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_retired_date !==
                          ""
                            ? format_dmy(
                                this.state.detail.retired_employee_retired_date
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">TMT Pemberhentian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .retired_employee_retired_date_tmt !== ""
                            ? format_dmy(
                                this.state.detail
                                  .retired_employee_retired_date_tmt
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Jenis</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_type_name !== ""
                            ? this.state.detail.retired_type_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Jenis Pemberhentian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_type_stop_name !== ""
                            ? this.state.detail.retired_type_stop_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Usia Sekarang</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_age !== ""
                            ? this.state.detail.employee_age
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Usia Pensiun</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_age_retired !== ""
                            ? this.state.detail.employee_age_retired
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Sisa Masa Kerja</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_work_age !== ""
                            ? this.state.detail.employee_work_age
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="3">
                      <label className="col-form-label" id="label_tusk">
                        TUSK{" "}
                      </label>
                      <Tooltip
                        style={this.state.tooltipStyle}
                        arrowClassName="custom-arrow"
                        placement="right"
                        isOpen={this.state["label_tusk"]}
                        target="label_tusk"
                        toggle={() => {
                          this.setState({
                            ["label_tusk"]: !this.state["label_tusk"],
                          });
                        }}
                      >
                        Masa Tunggu SK
                      </Tooltip>
                    </Col>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_tusk !== ""
                            ? this.state.detail.retired_employee_tusk
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="3">
                      <label className="col-form-label" id="label_mpp">
                        MPP{" "}
                      </label>
                      <Tooltip
                        style={this.state.tooltipStyle}
                        arrowClassName="custom-arrow"
                        placement="right"
                        isOpen={this.state["label_mpp"]}
                        target="label_mpp"
                        toggle={() => {
                          this.setState({
                            ["label_mpp"]: !this.state["label_mpp"],
                          });
                        }}
                      >
                        Masa Persiapan Pensiun
                      </Tooltip>
                    </Col>

                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_mpp !== ""
                            ? this.state.detail.retired_employee_mpp
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tempat KPPN</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_kppn_place !== ""
                            ? this.state.detail.retired_employee_kppn_place
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Bank</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_bank_name !== ""
                            ? this.state.detail.retired_employee_bank_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Nomor Rekening</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_bank_number !== ""
                            ? this.state.detail.retired_employee_bank_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <hr />
                  <h4>Dokumen Persyaratan</h4>
                  <br />

                  {this.state.dokumen_persyaratan.map((data, index) => {
                    return (
                      <Row className="mb-3">
                        <Col md="3">
                          <label
                            className="col-form-label"
                            id={`file-${data.uuid}`}
                          >
                            {data.label}{" "}
                            {data.is_required === 1 ? (
                              <span className="text-danger">*</span>
                            ) : (
                              ""
                            )}
                          </label>
                          <Tooltip
                            style={this.state.tooltipStyle}
                            arrowClassName="custom-arrow"
                            placement="right"
                            isOpen={this.state["file-" + data.uuid]}
                            target={`file-${data.uuid}`}
                            toggle={() => {
                              this.setState({
                                ["file-" + data.uuid]:
                                  !this.state["file-" + data.uuid],
                              });
                            }}
                          >
                            {data.tooltip}
                          </Tooltip>
                        </Col>
                        <Col md="9">
                          {data.path ? (
                            <>
                              {data.path !== "" ? (
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  class="btn btn-sm btn-primary"
                                  href={data.path}
                                >
                                  <i className="uil-file-download"></i> Download
                                  File
                                </a>
                              ) : (
                                "Tidak ada dokumen"
                              )}
                            </>
                          ) : (
                            <a
                              href="#"
                              class="btn btn-sm btn-secondary disabled"
                            >
                              <i className="uil-file-download"></i> Download
                              File
                            </a>
                          )}
                        </Col>
                      </Row>
                    );
                  })}

                  <Row className="mb-3">
                    <Col md="3"></Col>
                    <Col md="9">
                      <Link to={`?pegawai&uuid=` + this.state.submission_uuid}>
                        <Button color="danger">
                          <i className="uil-arrow-left"></i> Kembali
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
